import { Routes } from '@angular/router';
import { DefaultLayoutComponent } from './layout';
import { authGuard, hasAccessGuard, hasProductOwnerGuard, hideItemForBasicPlanAccessGuard } from './auth.guard'; // ✅ import the guard
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/routes').then((m) => m.routes),
        canActivate: [authGuard]
      },
      { 
        path: 'category', 
        data: { title: 'Category', permission: 'categories_view' }, 
        loadComponent: () => import('./category/category.component').then(m => m.CategoryComponent),
        canActivate: [authGuard, hasAccessGuard]
      },
      { 
        path: 'notifications', 
        data: { title: 'Notifications'}, 
        loadComponent: () => import('./notification/notification.component').then(m => m.NotificationComponent),
        canActivate: [authGuard]
      },{ 
        path: 'sop-pending-approval', 
        data: { title: 'Pending Approval', permission: 'sops_publish' }, 
        loadComponent: () => import('./sop/sop-pending-approval/sop-pending-approval.component').then(m => m.SopPendingApprovalComponent),
        canActivate: [authGuard, hideItemForBasicPlanAccessGuard]
      },
      { 
        path: 'sop', 
        data: { title: 'SOP', permission: 'sops_view' }, 
        loadComponent: () => import('./sop/sop-list/sop-list.component').then(m => m.SopListComponent),
        canActivate: [authGuard, hasAccessGuard]
      },
      { path: 'sop/templates',
        data: { title: 'SOP Templates', permission: 'sops_add' },
        loadComponent: () => import('./sop/sop-template-list/sop-template-list.component').then(m => m.SopTemplateListComponent),
        canActivate: [authGuard, hasAccessGuard]
      },
      { path: 'sop/new', 
        data: { title: 'Add SOP', permission: 'sops_add' }, 
        loadComponent: () => import('./sop/sop-form/sop-form.component').then(m => m.SopFormComponent),
        canActivate: [authGuard, hasAccessGuard]
      },
      { path: 'sop/:id', 
        data: { title: 'Edit SOP', permission: 'sops_edit'}, 
        loadComponent: () => import('./sop/sop-form/sop-form.component').then(m => m.SopFormComponent),
        canActivate: [authGuard, hasAccessGuard]
      },
      { path: 'sop-archived', 
        data: { title: 'Archived SOP', permission: 'sops_view', archived: true}, 
        loadComponent: () => import('./sop/sop-list/sop-list.component').then(m => m.SopListComponent),
        canActivate: [authGuard, hasAccessGuard]
      },
      { 
        path: 'company', 
        data: { title: 'Company' }, 
        loadComponent: () => import('./company/company-list/company-list.component').then(m => m.CompanyListComponent),
        canActivate: [authGuard, hasProductOwnerGuard]
      },
      { path: 'company/new', 
        data: { title: 'Add Company' }, 
        loadComponent: () => import('./company/company-form/company-form.component').then(m => m.CompanyFormComponent),
        canActivate: [authGuard, hasProductOwnerGuard]
      },
      { path: 'company/:id', 
        data: { title: 'Edit Company'}, 
        loadComponent: () => import('./company/company-form/company-form.component').then(m => m.CompanyFormComponent),
        canActivate: [authGuard, hasProductOwnerGuard]
      },
      { 
        path: 'user', 
        data: { title: 'Users', permission: 'users_view' }, 
        loadComponent: () => import('./user-management/user-management.component').then(m => m.UserManagementComponent),
        canActivate: [authGuard, hasAccessGuard]
      },
      { 
        path: 'profile', 
        data: { title: 'My Profile'}, 
        loadComponent: () => import('./views/pages/profile/profile.component').then(m => m.UserProfileComponent),
        canActivate: [authGuard]
      },
      { 
        path: 'roles', 
        data: { title: 'Roles' }, 
        loadComponent: () => import('./roles-management/roles-management.component').then(m => m.RolesManagementComponent),
        canActivate: [authGuard, hasAccessGuard]
      },
      {
        path: 'theme',
        loadChildren: () => import('./views/theme/routes').then((m) => m.routes)
      },
      {
        path: 'base',
        loadChildren: () => import('./views/base/routes').then((m) => m.routes)
      },
      {
        path: 'buttons',
        loadChildren: () => import('./views/buttons/routes').then((m) => m.routes)
      },
      {
        path: 'forms',
        loadChildren: () => import('./views/forms/routes').then((m) => m.routes)
      },
      {
        path: 'icons',
        loadChildren: () => import('./views/icons/routes').then((m) => m.routes)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./views/notifications/routes').then((m) => m.routes)
      },
      {
        path: 'widgets',
        loadChildren: () => import('./views/widgets/routes').then((m) => m.routes)
      },
      {
        path: 'charts',
        loadChildren: () => import('./views/charts/routes').then((m) => m.routes)
      },
      {
        path: 'pages',
        loadChildren: () => import('./views/pages/routes').then((m) => m.routes)
      }
    ]
  },
  {
    path: '404',
    loadComponent: () => import('./views/pages/page404/page404.component').then(m => m.Page404Component),
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    loadComponent: () => import('./views/pages/page500/page500.component').then(m => m.Page500Component),
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    loadComponent: () => import('./views/pages/login/login.component').then(m => m.LoginComponent),
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    loadComponent: () => import('./views/pages/register/register.component').then(m => m.RegisterComponent),
    data: {
      title: 'Register Page'
    }
  },
  { path: '**', redirectTo: 'dashboard' }
];
